import './BlogOverview.css';
import Bloglist from "../components/Blog/Bloglist";

const DUMMY_DATA = [
    {
        id: 'b1',
        date: '10 november 2020',
        author: 'Marielle',
        title: 'Complexiteit op de werkvloer',
        image: '/Users/lilianetop/Desktop/emergentia_frontend/public/images/joel-bengs-arYiUpN5tZk-unsplash.jpg',
        intro: 'De enige constante is verandering. Dat is niet alleen een boeddhistische wijsheid, maar anno 2021 voelbaar voor iedereen. Turbulentie en snelle verandering zijn misschien wel het nieuwe normaal. En dat is best ongemakkelijk. Stiekem houden we als mens juist van overzicht, stabiliteit en voorspelbaarheid. Als dat er niet is, lijkt het alsof je geen vaste grond onder je voeten hebt. Ongemakkelijk dus.',
        text: ''

    },
    {
        id: 'b2',
        title: 'Dit is de tweede blog',
        date: '15 oktober 2021',
        author: 'Marielle Slierendrecht',
        image: 'public/images/joel-bengs-arYiUpN5tZk-unsplash.jpg',
        intro: 'De enige constante is verandering. Dat is niet alleen een boeddhistische wijsheid, maar anno 2021 voelbaar voor iedereen. Turbulentie en snelle verandering zijn misschien wel het nieuwe normaal. En dat is best ongemakkelijk. Stiekem houden we als mens juist van overzicht, stabiliteit en voorspelbaarheid. Als dat er niet is, lijkt het alsof je geen vaste grond onder je voeten hebt. Ongemakkelijk dus.',
        text: ''
    }
];

function BlogOverview() {
    return (
        <section>
            <h2>Overzicht van alle blogpost</h2>
            <Bloglist blogs={DUMMY_DATA}/>
        </section>
    )
}

export default BlogOverview;